import React from "react"
import { useQuery } from "@apollo/client"
import GET_BUNDLE_GROUP from "../../../../graphql/queries/bundles/GetBundleGroup"
import { BundleOutcome } from "lib/types/generated/graphql-types"
import { Discount, Id, OrderLineDiscount, RuleContainer, RuleTotal } from "./Shared.styled"
import { Link } from "react-router-dom"
import Money from "../../../Money"
import DineroFactory from "dinero.js"

type Props = {
  bundle: BundleOutcome
  currencyUnit: string
  salePriceAmount: number
}

const BundleRule = ({ bundle, currencyUnit, salePriceAmount }: Props) => {
  const { data } = useQuery(GET_BUNDLE_GROUP, { variables: { id: bundle.bundleGroupId } })
  const bundleGroup = data?.getBundleGroup

  const getPercentage = (discountAmount: number, salePriceAmount: number) => {
    return ((discountAmount / salePriceAmount) * 100).toFixed(0)
  }

  return (
    <RuleContainer>
      <div>
        <b>Bundle: {bundleGroup?.name}</b>
        <Id>
          Bundle id: <Link to={`/discounts/bundle-groups/${bundleGroup?.id}`}>{bundle?.bundleId}</Link>
        </Id>
      </div>
      <RuleTotal>
        <Discount>
          <OrderLineDiscount>
            <div>Discount:</div>
            <div>
              {"- "}
              <Money
                amount={bundle?.discountAmount ?? 0}
                currencyUnit={currencyUnit as DineroFactory.Currency}
              />
            </div>
          </OrderLineDiscount>
          <OrderLineDiscount>
            <div>Discount percentage:</div>
            {getPercentage(bundle?.discountAmount ?? 0, salePriceAmount)}
            {"%"}
          </OrderLineDiscount>
        </Discount>
      </RuleTotal>
    </RuleContainer>
  )
}

export default BundleRule